import type { TransactionFile } from "@aircap/common/transaction";

export type FileUrlDisposition = "inline" | "attachment";

export const getFileExtension = (file: Pick<TransactionFile, "name">) => {
  const dotIndex = file.name.lastIndexOf(".");
  return dotIndex > 0 ? file.name.slice(dotIndex + 1).toUpperCase() : "";
};

export const getFileIcon = (file: Pick<TransactionFile, "name" | "type">) => {
  const extension = getFileExtension(file);
  if (file.type === "application/pdf" || extension === "PDF")
    return { icon: "mdi-file-pdf-box", color: "#E53935" };
  if (file.type.startsWith("image/")) return { icon: "mdi-file-image", color: "#1E88E5" };
  if (["DOC", "DOCX", "ODT"].includes(extension))
    return { icon: "mdi-file-word", color: "#2B579A" };
  if (["XLS", "XLSX", "ODS", "CSV"].includes(extension))
    return { icon: "mdi-file-excel", color: "#217346" };
  return { icon: "mdi-file", color: undefined };
};
